import React from "react";
// import classnames from 'classnames';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter, Link } from "react-router-dom";

import {
  AppBar,
  Toolbar,
  Button,
  IconButton,
  Typography,
} from "@material-ui/core";
import AccountCircle from "@material-ui/icons/AccountCircle";
import logo from "../../images/logo.png";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import AttachMoneyIcon from "@material-ui/icons/AttachMoney";
import { Auth } from "aws-amplify";
import NotificationsNoneIcon from "@material-ui/icons/NotificationsNone";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
// import {MDBIcon} from "mdbreact";

import { logoutUser, clearDataEmail } from "../../Actions/actions";

class PartnerHeader extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      anchorEl: null,
    };
  }

  handleClick = (event) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  render() {
    const userObject = JSON.parse(localStorage.getItem("userObject"));
    const { profileName } = this.props.data;
    const { anchorEl } = this.state;

    return (
      <div>
        {userObject && userObject.userDto.parentAffiliateUser === "Yes" ? (    //Logging out
          <AppBar
            color="default"
            className="p-navbar header-partner"
            position="static"
          >
            <Toolbar className="navbar-custom">
              <Link to = "/parent-affiliate">
                <img
                  className="responsive-img p-header-logo marrel"
                  src={logo}
                  alt=""
                />
              </Link>
              <Typography variant="h6" />
              <div className="pos-rel mar-rel">
                <Button className="p-header-link" color="">
                  FAQs
                </Button>
                <Button className="p-header-link not-count" color="">
                  {" "}
                  <NotificationsNoneIcon className="p-m-icon " />{" "}
                  <span style={{ color: "black" }}>2</span>
                </Button>
                <Button className="p-header-link money-count" color="">
                  {" "}
                  <AttachMoneyIcon className="p-m-icon " />
                </Button>

                <Link to="/profile">
                  <Button className="p-header-link mob-hide" color="inherit">
                    {profileName && profileName}
                  </Button>
                </Link>
                <IconButton
                  color="inherit"
                  aria-label="account of current user"
                  aria-controls="menu-appbar"
                  aria-haspopup="true"
                  className="p-btn-profile "
                  onClick={this.handleClick}
                  // onClick={(event) => {
                  //     this.setState({ anchorEl: event.currentTarget });
                  // }}
                >
                  <ExpandMoreIcon className="p-down-icon" />
                  <AccountCircle
                    className="img-profile"
                    style={{ marginLeft: "12px" }}
                  />
                </IconButton>
                <Menu
                  style={{ marginTop: "40px" }}
                  id="menu-appbar"
                  // anchorEl={anchorEl}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                  }}
                  keepMounted
                  anchorEl={anchorEl}
                  open={Boolean(anchorEl)}
                  onClose={this.handleClose}

                  // open={openMenu}
                  // onClick={() => {
                  //     this.setState({
                  //         openMenu: false
                  //     })
                  // }}
                >
                  <MenuItem
                    onClick={async () => {
                      await localStorage.clear();
                      Auth.signOut().then(async () => {
                        await this.props.logoutUser();
                        this.props.clearDataEmail();
                        // this.context.router.history.push("/");
                        this.props.history.push("/");
                      });
                    }}
                  >
                    Log Out
                  </MenuItem>
                </Menu>
              </div>
            </Toolbar>
          </AppBar>
        ) : (
          //Before aligning
          //      <AppBar color="default" className="p-navbar header-partner" position="static">
          //     <Toolbar className="navbar-custom">
          //     <img className="responsive-img p-header-logo marrel"  src={logo} alt="" />
          //         <Typography variant="h6" />
          //         <div className="pos-rel mar-rel">
          //             <Button className="p-header-link" color="">Help</Button>
          //             <Button className="p-header-link mob-hide" color="inherit">{profileName && profileName}</Button>
          //             <IconButton color="inherit"

          //                 aria-label="account of current user"
          //                 aria-controls="menu-appbar"
          //                 aria-haspopup="true"

          //                 className="p-btn-profile "
          //                 onClick={this.handleClick}
          //             // onClick={(event) => {
          //             //     this.setState({ anchorEl: event.currentTarget });
          //             // }}
          //             >
          //                 <AccountCircle />
          //                 <ExpandMoreIcon className="p-down-icon " />
          //             </IconButton>
          //             <Menu
          //                 id="menu-appbar"
          //                 // anchorEl={anchorEl}
          //                 anchorOrigin={{
          //                     vertical: 'top',
          //                     horizontal: 'right',
          //                 }}
          //                 keepMounted
          //                 anchorEl={anchorEl}
          //                 open={Boolean(anchorEl)}
          //                 onClose={this.handleClose}

          //             // open={openMenu}
          //             // onClick={() => {
          //             //     this.setState({
          //             //         openMenu: false
          //             //     })
          //             // }}
          //             >
          //                 <MenuItem onClick={async () => {
          //                     await localStorage.clear();
          //                     Auth.signOut()
          //                         .then(async () => {
          //                             await this.props.logoutUser();
          //                             this.props.clearDataEmail();
          //                             // this.context.router.history.push("/");
          //                             this.props.history.push('/')
          //                         })

          //                 }}>Log Out</MenuItem>
          //             </Menu>

          //         </div>
          //     </Toolbar>

          // </AppBar>

          <AppBar
            color="default"
            className="p-navbar header-partner"
            position="static"
          >
            <Toolbar className="navbar-custom">
              <Link to= "/parent-affiliate">
                <img
                  className="responsive-img p-header-logo marrel"
                  src={logo}
                  alt=""
                />
              </Link>
              <Typography variant="h6" />
              <div className="pos-rel mar-rel">
                <Button className="p-header-link" color="">
                  FAQs
                </Button>
                <Button className="p-header-link not-count" color="">
                  {" "}
                  <NotificationsNoneIcon className="p-m-icon " />{" "}
                  <span style={{ color: "black" }}>2</span>
                </Button>
                <Button className="p-header-link money-count" color="">
                  {" "}
                  <AttachMoneyIcon className="p-m-icon " />
                </Button>

                <Link to="/profile">
                  <Button className="p-header-link mob-hide" color="inherit">
                    {profileName && profileName}
                  </Button>
                </Link>
                <IconButton
                  color="inherit"
                  aria-label="account of current user"
                  aria-controls="menu-appbar"
                  aria-haspopup="true"
                  className="p-btn-profile "
                  onClick={this.handleClick}
                  // onClick={(event) => {
                  //     this.setState({ anchorEl: event.currentTarget });
                  // }}
                >
                  <ExpandMoreIcon className="p-down-icon" />
                  <AccountCircle
                    className="img-profile"
                    style={{ marginLeft: "12px" }}
                  />
                </IconButton>
                <Menu
                  style={{ marginTop: "40px" }}
                  id="menu-appbar"
                  // anchorEl={anchorEl}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                  }}
                  keepMounted
                  anchorEl={anchorEl}
                  open={Boolean(anchorEl)}
                  onClose={this.handleClose}

                  // open={openMenu}
                  // onClick={() => {
                  //     this.setState({
                  //         openMenu: false
                  //     })
                  // }}
                >
                  <MenuItem
                    onClick={async () => {
                      await localStorage.clear();
                      Auth.signOut().then(async () => {
                        await this.props.logoutUser();
                        this.props.clearDataEmail();
                        // this.context.router.history.push("/");
                        this.props.history.push("/");
                      });
                    }}
                  >
                    Log Out
                  </MenuItem>
                </Menu>
              </div>
            </Toolbar>
          </AppBar>
        )}
      </div>
    );
  }
}
// const PartnerHeader = ({ userInfo: { userObject } }) => (
//     <AppBar color="default" className="p-navbar" position="static">
//         <Toolbar className="navbar-custom">
//             <img className="responsive-img p-header-logo" src={logo} alt="" />
//             <Typography variant="h6" />
//             <div>
//                 <Button className="p-header-link" color="">Help</Button>
//                 <Button className="p-header-link" color="inherit">{userObject && userObject.userDto && userObject.userDto.firstName}</Button>
//                 <IconButton color="inherit" className="p-btn-profile ">
//                     <AccountCircle />
//                     <ExpandMoreIcon className="p-down-icon " />
//                 </IconButton>

//             </div>
//         </Toolbar>

//     </AppBar>
// );

// PartnerHeader.propTypes = {
//     userInfo: PropTypes.any,
// };

const mapStateToProps = (state) => ({ data: state.data });

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      logoutUser,
      clearDataEmail,
    },
    dispatch
  );

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(PartnerHeader)
);
